const translateTrigger = document.getElementById("glt-translate-trigger");
const charcoalElements = document.querySelectorAll(
	'[data-background="charcoal"]'
);

const observer = new IntersectionObserver(
	(entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				translateTrigger?.setAttribute("data-background", "blue");
			} else {
				if (translateTrigger?.getAttribute("data-background") !== "charcoal") {
					translateTrigger?.setAttribute("data-background", "charcoal");
				}
			}
		});
	},
	{
		root: null, // Use the viewport as the root
		rootMargin: "0px", // No margin for the root
		threshold: 0.1, // Trigger when at least 10% of the element is visible
	}
);

// Observe each of the charcoal elements
charcoalElements.forEach((el) => observer.observe(el));
